module.exports = __webpack_public_path__ + "img/36_47.b4bc5481.png";